import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import Blade from '../Blade';
import { Kfh_StaffType } from '../../types/graphqlTypes';
import { Typography } from '../Typography';
import { Divider } from '../Divider';
import { Spacer } from '../Spacer';
import HtmlContent from '../Html';
import { Image } from '../Image';
import { LinkedIn } from '../icon/icons/LinkedIn';

interface StaffBladeProps {
  staff: Kfh_StaffType;
}

const StyledLinkedInLink = styled.a`
  ${({ theme: { space } }) => css`
    display: flex;
    align-items: center;
    gap: ${space.sm};
    text-decoration: none;
  `};
`;

export const StaffBlade: FC<StaffBladeProps> = ({ staff }) => {
  if (!staff) {
    return <></>;
  }
  const { fullName, bio, email, directDialNumber, keyResponsibilities, position, profile, startDate, mediaSet } = staff;

  // Profile image

  const profileImage = mediaSet?.media?.filter((mediaItem) => mediaItem.role === 'Profile')[0]?.media;

  return (
    <Blade id="staff">
      <Spacer>
        {profileImage && <Image image={profileImage} alt={fullName} />}

        {/* Heading and link */}

        <Spacer spacing="quarter">
          <Typography component="h2" variant="displaySmall">
            {fullName}
          </Typography>
          {position && (
            <Typography component="p" variant="lead">
              {position}
            </Typography>
          )}
        </Spacer>

        <Spacer spacing="quarter">
          {directDialNumber && (
            <div>
              <p>
                <strong>Telephone:</strong> {directDialNumber}
              </p>
            </div>
          )}
          {startDate && (
            <div>
              <p>
                <strong>Start date:</strong> {startDate}
              </p>
            </div>
          )}
          {profile && (
            <div>
              <StyledLinkedInLink href={profile} target="_blank">
                <LinkedIn /> View LinkedIn profile
              </StyledLinkedInLink>
            </div>
          )}
        </Spacer>

        {keyResponsibilities && (
          <>
            <Divider />
            <HtmlContent>{keyResponsibilities}</HtmlContent>
          </>
        )}

        {bio && (
          <>
            <Divider />
            <HtmlContent>{bio}</HtmlContent>
          </>
        )}
      </Spacer>
    </Blade>
  );
};

export default StaffBlade;
